import { render, staticRenderFns } from "./CarouselGallery.vue?vue&type=template&id=0f106ce0&scoped=true&"
import script from "./CarouselGallery.vue?vue&type=script&lang=js&"
export * from "./CarouselGallery.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGallery.vue?vue&type=style&index=0&id=0f106ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f106ce0",
  null
  
)

export default component.exports